import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3244bb94"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "ap-toggle-row"
}
const _hoisted_2 = {
  key: 0,
  class: "toggle-warning-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.allowed)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["ap-icon", _ctx.getIconClass]),
        style: _normalizeStyle({ color: _ctx.getSliderStyleColor })
      }, null, 6))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", {
          class: "ap-toggle",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.labelOnClick && _ctx.labelOnClick(...args)))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["slider round", { checked: _ctx.modelValue, 'disabled-toggle': _ctx.disabled }]),
            style: _normalizeStyle(_ctx.getSliderStyle)
          }, null, 6)
        ]),
        (_ctx.warningLabel && _ctx.modelValue)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.warningLabel), 1))
          : _createCommentVNode("", true)
      ]))
}